import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/expense/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/expense/reports" });
  },
});
